import { useQuery } from "@apollo/client"
import GET_DISCOUNT_CODE_RULE from "graphql/queries/discount/GetDiscountCodeRule"

export const useGetDiscountCodeRule = (id: string) =>
  useQuery(GET_DISCOUNT_CODE_RULE, {
    variables: { id }
  })
